module.exports = __webpack_public_path__ + "static/media/nia_black_friday_hero.311d1008.gif";